/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_TitleInputs */

const en_feedback_title = /** @type {(inputs: Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback`)
};

const id_feedback_title = /** @type {(inputs: Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masukan`)
};

/**
* | output |
* | --- |
* | "Feedback" |
*
* @param {Feedback_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const feedback_title = /** @type {((inputs?: Feedback_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_feedback_title(inputs)
	return en_feedback_title(inputs)
});